import { render, staticRenderFns } from "./Consultation.vue?vue&type=template&id=58a3c0f2"
import script from "./Consultation.vue?vue&type=script&lang=js"
export * from "./Consultation.vue?vue&type=script&lang=js"
import style0 from "./Consultation.vue?vue&type=style&index=0&id=58a3c0f2&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a3c0f2')) {
      api.createRecord('58a3c0f2', component.options)
    } else {
      api.reload('58a3c0f2', component.options)
    }
    module.hot.accept("./Consultation.vue?vue&type=template&id=58a3c0f2", function () {
      api.rerender('58a3c0f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/user/Consultation.vue"
export default component.exports